//deps
import React, { memo, useMemo } from "react";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";
import { getTitleConfig, getVariantFromText } from "@super-ui/components/m2c-swiggy-black-halfcard/helpers";

// styles
import { ContentContainer, ContentText, ContentTextWrapper } from "../styles";

//constants
import { M2C_HALFCARD_TEST_IDS } from "@super-ui/components/m2c-swiggy-black-halfcard/constants";

const ContentItem = ({ title, isBlackRenewalType }: { title: string; isBlackRenewalType: boolean }) => {
    const titleConfig = useMemo(() => getTitleConfig(title), [title]);
    const { cloudinaryId, width, height } = titleConfig.imageConfig;
    const variants = useMemo(() => getVariantFromText(titleConfig.title), [titleConfig.title]);

    return (
        <ContentContainer data-testid={M2C_HALFCARD_TEST_IDS.CONTENT_ITEM}>
            {!isEmpty(cloudinaryId) && <Image cloudinaryId={cloudinaryId} width={width} height={height} />}
            <ContentTextWrapper>
                {variants?.map(textProp => (
                    <ContentText
                        isBlackRenewalType={isBlackRenewalType}
                        key={textProp?.variant}
                        variant={textProp?.variant}
                        color={textProp?.color}
                        dangerouslySetInnerHTML={{ __html: textProp?.text }}
                    />
                ))}
            </ContentTextWrapper>
        </ContentContainer>
    );
};

export default memo(ContentItem);
